export const documentTemplates: Record<string, { name: string; description: string }> = {};
export function getTemplate(key: string) { return documentTemplates[key] || null; }

function openHTML(html: string) {
  const w = window.open("", "_blank");
  if (w) { w.document.write(html); w.document.close(); }
}

export function openDocumentForPrint(html: string) {
  const w = window.open("", "_blank");
  if (w) { w.document.write(html); w.document.close(); w.print(); }
}

export function generateFOIARequest(data: any): string {
  return `<!DOCTYPE html><html><head><title>FOIA Request</title></head><body>
<h1>Freedom of Information Act Request</h1>
<p>Date: ${new Date().toLocaleDateString()}</p>
<pre>${JSON.stringify(data, null, 2)}</pre>
</body></html>`;
}

export function generateCaseReport(data: any): string {
  return `<!DOCTYPE html><html><head><title>Case Report</title></head><body>
<h1>Case Analysis Report</h1>
<p>Generated: ${new Date().toISOString()}</p>
<pre>${JSON.stringify(data, null, 2)}</pre>
</body></html>`;
}

export function generateEscalationLetter(data: any): string {
  return `<!DOCTYPE html><html><head><title>Escalation Letter</title></head><body>
<h1>Escalation Letter</h1>
<p>Date: ${new Date().toLocaleDateString()}</p>
<pre>${JSON.stringify(data, null, 2)}</pre>
</body></html>`;
}
